<style lang="scss" scoped>
  .swiper-container {
    width: 1280px;
    height: 300px;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 300px;
      }
    }
  }
</style>

<template>
  <div class="swiper-container">
    <img :src="slides[0].imgUrl" style="width: 100%;height: 100%;display: block" v-if="slides.length==1"/>
    <div class="swiper-wrapper" v-if="slides.length>1">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- 幻灯内容 -->
        <swiper-slide v-for="(itemImg,index) in slides" :key="itemImg.imgUrl">
          <img :src=itemImg.imgUrl @click="clickEvent(index)">
        </swiper-slide>
        <!-- 以下控件元素均为可选 -->
        <div class="swiper-pagination" v-show="slides.length>1" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          // swiper configs 所有的配置同swiper官方api配置
          autoplay: 3000,
          effect : 'fade',
          initialSlide: 0,
          pagination:'.swiper-pagination',
          autoplayDisableOnInteraction:false,
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable:true
          // },
          speed: 1000,
          direction: 'horizontal',
          paginationClickable: true,
          mousewheelControl: true,
          // autoplay:{
          //   delay: 3000,
          //   stopOnLastSlide: false,
          //   disableOnInteraction: false,
          // },
        }
      }
    },
    props:{
      slides:{
        type: Array
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    components:{
      swiper,swiperSlide
    },
    mounted() {
      setTimeout(() => {
        this.swiepr = this.$refs.mySwiper.swiper
      }, 20);
    },
    beforeDestroy(){
      this.swiper = null
    }
  }
</script>



// WEBPACK FOOTER //
// swiper.vue?7f33144a